import { Link } from "react-router-dom";
import logoimg from "../../assets/img/icon.png";
import DashboardLayout from "../../hocs/layout/DashboardLayout";
import { Helmet } from "react-helmet-async";
import { connect } from "react-redux";

function Error404({
	isAuthenticated
}) {
  return (
    <DashboardLayout>
      <Helmet>
        <title>404 | TableChat</title>
      </Helmet>

      <main role="main" className="min-h-[70vh] flex items-center justify-center">
        <div className="w-full max-w-2xl mx-auto px-4 py-12 text-center">
          {/* Logo */}
          <Link to="/" className="inline-flex items-center justify-center">
            <img
              src={logoimg}
              className="w-20 h-20 rounded-full shadow-md ring-4 ring-white/60"
              alt="Logo TableChat"
            />
          </Link>

          {/* Código 404 con degradado */}
          <h1 className="mt-6 font-black leading-none tracking-tight text-transparent bg-clip-text bg-gradient-to-r from-[#ff1049] to-[#ff7826]
                         text-[6rem] sm:text-[8rem] md:text-[10rem]">
            404
          </h1>

          {/* Mensaje */}
          <p className="text-gray-700 text-base sm:text-lg">
            La página que intentas acceder no está disponible.
          </p>
          <p className="text-gray-500 text-sm mt-1">
            Puede que el enlace esté roto o la página haya sido movida.
          </p>

          {/* Acciones */}
          <div className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-3">
            <Link
              to="/"
              className="inline-flex items-center justify-center rounded-lg px-5 py-3 text-white font-semibold
                         bg-gradient-to-r from-[#ff1049] to-[#ff7826]
                         hover:opacity-95 focus:outline-none focus:ring-2 focus:ring-[#ff1049]/40 focus:ring-offset-2"
            >
              Volver al inicio
            </Link>
           { isAuthenticated && ( <Link
              to="/dashboard"
              className="inline-flex items-center justify-center rounded-lg px-5 py-3 font-semibold
                         text-[#ff1049] border border-[#ff1049]/30 bg-white hover:bg-[#ff1049]/5"
            >
              Ir al Dashboard
            </Link> )}
          </div>
        </div>
      </main>
    </DashboardLayout>
  );
}


const mapStateToProps = (state) => ({
	isAuthenticated: state.auth.isAuthenticated,
});

export default connect(mapStateToProps)(Error404);
